document.addEventListener('DOMContentLoaded', () => {
  const priceBreakupDiv = document.querySelector('#price-breakup');

  if (!priceBreakupDiv) return;

  const calculatePriceBreakdown = () => {
    // Get selected size and type
    const selectedSize = document.querySelector('[name="Size"]:checked')?.value || 7; // Default to size 7
    const selectedType = document.querySelector('[name="Type"]:checked')?.value || '18k'; // Default to 18k

    // Base values from data attributes
    const standardWeight = parseFloat(priceBreakupDiv.dataset.standardWeight || 3); // Default weight (3g)
    const goldRate24k = parseFloat(priceBreakupDiv.dataset.goldRate24k || 0); // Base price for 24k gold
    const makingChargeRate = parseFloat(priceBreakupDiv.dataset.makingChargeRate || 0);

    // Adjust weight based on size (example logic, update as per requirement)
    const weightAdjustment = (parseInt(selectedSize) - 7) * 0.1; // Example: +/-0.1g per size increment
    const weight = standardWeight + weightAdjustment;

    // Calculate gold rate based on type
    const goldRate = selectedType === '22k' ? goldRate24k * 0.916 : goldRate24k * 0.75;

    // Validate fetched data
    if (isNaN(weight) || isNaN(goldRate) || isNaN(makingChargeRate)) {
      console.error("Invalid data for weight, gold rate, or making charge.");
      return;
    }

    // Perform calculations
    const goldPrice = weight * goldRate;
    const makingCharges = weight * makingChargeRate;
    const totalValue = goldPrice + makingCharges;

    // Update the price breakdown in HTML
    priceBreakupDiv.innerHTML = `
      <table>
          <tr><td>Gold Price (${selectedType})</td><td>${weight.toFixed(2)}g x ₹${goldRate.toFixed(2)}</td><td>₹${goldPrice.toFixed(2)}</td></tr>
          <tr><td>Making Charges</td><td>${weight.toFixed(2)}g x ₹${makingChargeRate.toFixed(2)}</td><td>₹${makingCharges.toFixed(2)}</td></tr>
          <tr><td>Total</td><td></td><td>₹${totalValue.toFixed(2)}</td></tr>
      </table>
    `;
  };

  // Trigger on size/type selection
  const inputs = document.querySelectorAll('[name="Size"], [name="Type"]');
  inputs.forEach(input => {
    input.addEventListener('change', calculatePriceBreakdown);
  });

  // Initial calculation
  calculatePriceBreakdown();
});
